import { getV1Config } from '@host-panel/request/config';

export async function getModerationPreferences(spotId: string) {
  return getV1Config(spotId, ['multiple_moderators_mode', 'user_moderation_enabled']);
}
